import { Facebook, Twitter, Linkedin, Youtube } from 'lucide-react';

export default function Footer() {
  return (
    <footer>
      <div className="footer-grid">
        <div className="footer-brand">
          <div className="footer-logo">
            <div className="logo-icon" style={{ width: 30, height: 30, borderRadius: 8 }}><img src={process.env.PUBLIC_URL + '/logo.png'} alt="TIGOO" /></div>
            <span className="footer-logo-text">TIGOO</span>
          </div>
          <p>
            La plateforme qui connecte les amateurs de pronostics sportifs avec les meilleurs talents.
            Decouvrez les coupons des pronostiqueurs les plus performants.
          </p>
          <div className="footer-socials">
            <a href="#" className="social-btn" aria-label="Facebook"><Facebook size={16} /></a>
            <a href="#" className="social-btn" aria-label="Twitter"><Twitter size={16} /></a>
            <a href="#" className="social-btn" aria-label="LinkedIn"><Linkedin size={16} /></a>
            <a href="#" className="social-btn" aria-label="YouTube"><Youtube size={16} /></a>
          </div>
        </div>
        <div className="footer-col">
          <h4>A propos</h4>
          <a href="#">Notre club</a>
          <a href="#">Conditions generales</a>
          <a href="#">Politique de confidentialite</a>
        </div>
        <div className="footer-col">
          <h4>Support</h4>
          <a href="#">Aide & FAQ</a>
          <a href="#">Contact</a>
          <a href="#">Signaler un probleme</a>
        </div>
        <div className="footer-col">
          <h4>Sports</h4>
          <a href="#">Football</a>
          <a href="#">Basketball</a>
          <a href="#">Tennis</a>
          <a href="#">Tous les sports</a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2026 TIGOO. Tous droits reserves.</p>
      </div>
    </footer>
  );
}
